import { ArrayParam, useQueryParams } from "use-query-params";
import { useOperator, useSearch } from "@/hooks";
import { GetUninvoicedJobsCompaniesParams } from "@/redux/apis/company/types";
import { UninvoicedJobsFilterFormData } from "../types";

const FiltersParam = {
  generateOnFrequency: ArrayParam,
};

export const useGetUninvoicedJobsCompaniesParams = () => {
  const { providerCode } = useOperator();
  const [search, setSearch] = useSearch();
  const [filters, setFilters] = useQueryParams(FiltersParam);

  const params: GetUninvoicedJobsCompaniesParams = {
    search: search ?? undefined,
    generate_on_frequency: filters.generateOnFrequency ? (filters.generateOnFrequency.filter(Boolean) as string[]) : undefined,
    include_invoice_metadata: providerCode === "adelaide-chauffeur-company" ? undefined : "1",
  };

  return {
    params,
    search: params.search,
    setSearch,
    filters: {
      generateOnFrequency: params.generate_on_frequency,
    } as UninvoicedJobsFilterFormData,
    setFilters,
  };
};
